var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import { MEDIA_QUERIES } from 'shared/style';
import Product from './Product';
import Title from 'components/shared/Title';
var RootDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    display: none;\n  }\n\n  ", " {\n    width: 100%;\n    min-height: 80vh;\n    padding: 100px 0;\n    overflow: hidden;\n    background-color: #f8f8f8;\n\n    > .title {\n      width: 100%;\n      padding: 0 20px 50px;\n    }\n  }\n"], ["\n  ", " {\n    display: none;\n  }\n\n  ", " {\n    width: 100%;\n    min-height: 80vh;\n    padding: 100px 0;\n    overflow: hidden;\n    background-color: #f8f8f8;\n\n    > .title {\n      width: 100%;\n      padding: 0 20px 50px;\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE);
var MobileProducts = /** @class */ (function (_super) {
    __extends(MobileProducts, _super);
    function MobileProducts() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileProducts.prototype.render = function () {
        var products = this.props.products;
        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (React.createElement(RootDiv, null,
            React.createElement("div", { className: "title" },
                React.createElement(Title, { title: '제품소개', color: '#000' })),
            React.createElement(Slider, __assign({}, settings), products.map(function (product, idx) {
                return (React.createElement("div", { key: idx },
                    React.createElement(Product, { product: product })));
            }))));
    };
    return MobileProducts;
}(React.Component));
export default MobileProducts;
var templateObject_1;
